import {Injectable} from "@angular/core";

@Injectable()

export class NotificationProvider {
    constructor() { }
    
    
}
